import { styled } from '@mui/material/styles';
import { useTranslate } from 'src/locales';

const LanguageSwitchContainer = styled('div')({
  display: 'inline-flex',
  backgroundColor: '#10C378',
  borderRadius: '20px',
  padding: '3px',
  position: 'relative',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: '#0ca268',
  },
});

const LanguageOption = styled('div')({
  padding: '4px 10px',
  fontSize: '14px',
  fontWeight: '800',
  zIndex: 1,
  color: 'rgba(255, 255, 255, 0.7)',
  transition: 'color 0.2s ease',
  minWidth: '36px',
  textAlign: 'center',
});

const Slider = styled('div')({
  position: 'absolute',
  top: '4px',
  height: 'calc(100% - 8px)',
  width: '36px',
  backgroundColor: '#fff',
  borderRadius: '16px',
  transition: 'transform 0.3s ease',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
});

export function LanguageSwitch() {
  const { onChangeLang, currentLang } = useTranslate();

  const handleLanguageSwitch = () => {
    const nextLang = currentLang.value === 'th' ? 'en' : 'th';
    onChangeLang(nextLang);
  };

  return (
    <LanguageSwitchContainer onClick={handleLanguageSwitch}>
      <Slider
        sx={{
          transform: currentLang.value === 'th' ? 'translateX(40px)' : 'translateX(1px)',
        }}
      />
      <LanguageOption
        sx={{
          color: currentLang.value === 'en' ? '#10C378' : 'rgba(255, 255, 255, 0.9)',
        }}
      >
        EN
      </LanguageOption>
      <LanguageOption
        sx={{
          color: currentLang.value === 'th' ? '#10C378' : 'rgba(255, 255, 255, 0.9)',
        }}
      >
        TH
      </LanguageOption>
    </LanguageSwitchContainer>
  );
}
